import { Action } from 'redux';
import { Prefactura } from '../../../models/Entities/Turnero';
import { TurneroPrefacturadorState, TurneroPrefacturadorUnloadState } from '../../states/Turnero-Prefacturador.State';

export default function TurneroPrefacturadorReducer(
    state: TurneroPrefacturadorState | undefined,
    action: Action
): TurneroPrefacturadorState {
    const currentState = state ?? TurneroPrefacturadorUnloadState;
    const a: any = action;

    switch (a.type) {
        case 'TURNERO-PREFACTURADOR_GENERAR_REQUEST':
            return {
                ...currentState,
                isAddingNewOne: true,
                successAddingNewOne: false,
                failOnAddingNewOne: false,
                error: undefined
            } as TurneroPrefacturadorState;
        case 'TURNERO-PREFACTURADOR_GENERAR_SUCCESS':
            return {
                ...currentState,
                isAddingNewOne: false,
                successAddingNewOne: true,
                failOnAddingNewOne: false,
                error: undefined,
                current: a.payload,
                list: [...(currentState.list || []), a.payload]
            } as TurneroPrefacturadorState;
        case 'TURNERO-PREFACTURADOR_GENERAR_FAILURE':
            return {
                ...currentState,
                isAddingNewOne: false,
                successAddingNewOne: false,
                failOnAddingNewOne: true,
                error: a.error
            } as TurneroPrefacturadorState;

        case 'TURNERO-PREFACTURADOR_GET_BY_ID_REQUEST':
            return {
                ...currentState,
                isLoadingOne: true,
                successLoadingOne: false,
                failOnLoadingOne: false,
                error: undefined
            } as TurneroPrefacturadorState;
        case 'TURNERO-PREFACTURADOR_GET_BY_ID_SUCCESS': {
            const updatedList = [...(currentState.list || []).filter((p: Prefactura) => p.id !== a.payload.id), a.payload];
            return {
                ...currentState,
                isLoadingOne: false,
                successLoadingOne: true,
                failOnLoadingOne: false,
                error: undefined,
                current: a.payload,
                list: updatedList
            } as TurneroPrefacturadorState;
        }
        case 'TURNERO-PREFACTURADOR_GET_BY_ID_FAILURE':
            return {
                ...currentState,
                isLoadingOne: false,
                successLoadingOne: false,
                failOnLoadingOne: true,
                error: a.error
            } as TurneroPrefacturadorState;

        case 'TURNERO-PREFACTURADOR_GET_ALL_REQUEST':
            return {
                ...currentState,
                ...(a.estado ? { isLoadingPorEstado: true, successLoadingPorEstado: false, failOnLoadingPorEstado: false } : { isLoadingAll: true, successLoadingAll: false, failOnLoadingAll: false }),
                error: undefined
            } as TurneroPrefacturadorState;
        case 'TURNERO-PREFACTURADOR_GET_ALL_SUCCESS': {
            const baseState = {
                ...currentState,
                ...(a.estado ? { isLoadingPorEstado: false, successLoadingPorEstado: true, failOnLoadingPorEstado: false } : { isLoadingAll: false, successLoadingAll: true, failOnLoadingAll: false }),
                error: undefined
            } as TurneroPrefacturadorState;
            if (a.estado) {
                return { ...baseState, porEstado: a.payload || [] } as TurneroPrefacturadorState;
            }
            return { ...baseState, list: a.payload || [] } as TurneroPrefacturadorState;
        }
        case 'TURNERO-PREFACTURADOR_GET_ALL_FAILURE':
            return {
                ...currentState,
                ...(a.estado ? { isLoadingPorEstado: false, successLoadingPorEstado: false, failOnLoadingPorEstado: true } : { isLoadingAll: false, successLoadingAll: false, failOnLoadingAll: true }),
                error: a.error
            } as TurneroPrefacturadorState;

        case 'TURNERO-PREFACTURADOR_ACTUALIZAR_ESTADO_REQUEST':
            return {
                ...currentState,
                isUpdatingEstado: true,
                successUpdatingEstado: false,
                failOnUpdatingEstado: false,
                error: undefined
            } as TurneroPrefacturadorState;
        case 'TURNERO-PREFACTURADOR_ACTUALIZAR_ESTADO_SUCCESS': {
            const updatedList = (currentState.list || []).map((p: Prefactura) =>
                p.id === a.id ? { ...p, estado: a.estado } : p
            );
            const updatedPorEstado = (currentState.porEstado || []).map((p: Prefactura) =>
                p.id === a.id ? { ...p, estado: a.estado } : p
            );
            return {
                ...currentState,
                isUpdatingEstado: false,
                successUpdatingEstado: true,
                failOnUpdatingEstado: false,
                error: undefined,
                list: updatedList,
                porEstado: updatedPorEstado
            } as TurneroPrefacturadorState;
        }
        case 'TURNERO-PREFACTURADOR_ACTUALIZAR_ESTADO_FAILURE':
            return {
                ...currentState,
                isUpdatingEstado: false,
                successUpdatingEstado: false,
                failOnUpdatingEstado: true,
                error: a.error
            } as TurneroPrefacturadorState;

        default:
            return currentState as TurneroPrefacturadorState;
    }
}
